<template>
  <div class="register_page">
    <!--Top Background-->
    <div class="top_background">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="title my_pack">
              <!-- <h4>{{ $t("search.title") }}</h4> -->
              <!--Company Info-->
              <div class="company_info">
                <img :src="userImage" />
                <h4>{{ userName }}</h4>
              </div>
              <!--Company Info-->

              <!--Package Info-->
              <div class="package_info">
                <!-- <p>{{ $t("navbar.likes") }}  <span></span></p> -->
              
              </div>
              <!--Package Info-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Top Background-->

    <!--Categories-->
    <div class="search_page">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <loader v-if="loading"></loader>
            <div v-else>
              <template v-if="users.length == 0">
                <not-found></not-found>
                <router-link
                  class="main_button"
                  to="/likes"
                  @click="getUsers"
                >
                  <span>{{ $t("navbar.likes") }}</span>
                </router-link>
              </template>
              <div class="row" v-else>
                <div class="col-lg-3" v-for="user in users" :key="user.id">
                  <EmployesCard
                    :employee="user"
                    :isLiked="user.IsLike"
                  ></EmployesCard>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <strong-cv></strong-cv>
      <newsleter></newsleter>
    </div>
    <!--Categories--->
  </div>
</template>

<script>
import Newsleter from "@/components/HomePage/Newsleter.vue";
import StrongCv from "@/components/HomePage/StrongCv.vue";
import EmployesCard from "@/components/Employes/Employes.vue";
export default {
  components: {
    Newsleter,
    StrongCv,
    EmployesCard,
  },
  data() {
    return {
      //START:: Filter Data
      filterData: {
        category: null,
        city: null,
        experience: null,
        type: null,
      },
      //END:: Filter Data

      //Loading
      loading: false,
      //Loading

      //START:: CATEGORIES
      categories: [],
      //END:: CATEGORIES

      //START:: CITIES
      cities: [],
      //END:: CITIES

      //START:: JOBS
      users: [],
      //END:: JOBS
    };
  },
  methods: {
    getData() {
      //====Cities=======
      this.$axios({
        method: "GET",
        url: "cities",
      }).then((res) => {
        this.cities = res.data.data;
      });
      //====Main Category=======
      this.$axios({
        method: "GET",
        url: "categories",
      }).then((res) => {
        this.categories = res.data.data;
      });
    },
    //=====Get Users
    getUsers() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: "company/searchlikes",
        params: {
          gender: this.filterData.type,
          category_id: this.filterData.category,
          city_id: this.filterData.city,
          experience_years: this.filterData.experience,
        },
      })
        .then((res) => {
          this.loading = false;
          this.users = res.data.data;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getData();
    this.getUsers();
  },
  computed: {
    userImage() {
      return this.$store.getters["auth_module/userImage"];
    },
    userName() {
      return this.$store.getters["auth_module/userName"];
    },
    expPackage() {
      return this.$store.getters["auth_module/expPackage"];
    },
  },
};
</script>

<style></style>
